import React, { useEffect } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';

import Layout from '../../shared/components/Layout/Layout';
import EasyJoinPage from './components/presentational/EasyJoinPage';
import {
  fetchEasyJoinCodes,
  createEasyJoinCode,
  updateEasyJoinCode,
  deleteEasyJoinCodes,
  clearLastCreated,
  clearLastUpdated,
} from './ducks/easyJoinActions';
import { fetchGroups, fetchCalendars } from '../navigator/ducks/navigatorActions';

const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-top: 49px;
`;

const EasyJoin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const backPath = location.state?.backPath;
  const backLabel = location.state?.backLabel;

  const accountCode = useSelector((state) => state.auth.data.currentUser?.accountCode);
  const codes = useSelector((state) => state.easyJoin.data.codes);
  const lastCreated = useSelector((state) => state.easyJoin.data.lastCreated);
  const lastUpdated = useSelector((state) => state.easyJoin.data.lastUpdated);
  const isLoadingCodes = useSelector((state) => state.easyJoin.ui.isLoadingCodes);
  const isCreating = useSelector((state) => state.easyJoin.ui.isCreating);
  const isUpdating = useSelector((state) => state.easyJoin.ui.isUpdating);
  const isDeleting = useSelector((state) => state.easyJoin.ui.isDeleting);
  const calendars = useSelector((state) => state.navigator.data.calendars);
  const groups = useSelector((state) => state.navigator.data.groups);

  useEffect(() => {
    if (accountCode) {
      batch(() => {
        dispatch(fetchEasyJoinCodes(accountCode));
        dispatch(fetchCalendars(accountCode));
        dispatch(fetchGroups(accountCode));
      });
    }
  }, [accountCode, dispatch]);

  const handleCreate = (values) => {
    dispatch(createEasyJoinCode(accountCode, values));
  };

  const handleUpdate = (easyJoinId, values) => {
    dispatch(updateEasyJoinCode(accountCode, easyJoinId, values));
  };

  const handleDelete = (ids) => {
    dispatch(deleteEasyJoinCodes(accountCode, ids));
  };

  const handleClearLastCreated = () => {
    dispatch(clearLastCreated());
  };

  const handleClearLastUpdated = () => {
    dispatch(clearLastUpdated());
  };

  return (
    <Layout fullWidth>
      <Helmet>
        <title>Easy Join | TeamBuildr</title>
      </Helmet>
      <Container>
        <EasyJoinPage
          codes={codes}
          calendars={calendars}
          groups={groups}
          isLoadingCodes={isLoadingCodes}
          isCreating={isCreating}
          isUpdating={isUpdating}
          isDeleting={isDeleting}
          lastCreated={lastCreated}
          lastUpdated={lastUpdated}
          onBack={backPath ? () => history.push(backPath) : null}
          backLabel={backLabel}
          onCreate={handleCreate}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          onClearLastCreated={handleClearLastCreated}
          onClearLastUpdated={handleClearLastUpdated}
        />
      </Container>
    </Layout>
  );
};

export default EasyJoin;
